<template>
  <div class="">
    <TopHeader />
    <div class="ps-3 mt-3">
      <div class="general-page px-4 py-3">
        <div class="d-flex justify-content-between align-items-center">
          <div class="px-2">
            <!-- <input type="text" v-model="roleName" @focus="roleNameEmpty = false" class="role-name-input" placeholder="Role Name" /> -->
            <!-- <div v-if="roleNameEmpty" style="color: red">Role name is required</div> -->
          </div>
          <router-link class="add-role" to="/users" title="Role">
            Back</router-link
          >
        </div>
        <div class="d-flex flex-wrap">
          <div class="mt-3 col-12 col-lg-6">
            <div class="input-box">
              <label class="mb-0" for="">Name</label>
              <input
                type="text"
                v-on:keyup.enter="save()"
                v-model="name"
                @focus="nameEmpty = false"
                placeholder="example (Arun)"
              />
              <div v-if="nameEmpty" style="color: red">Name is required</div>
            </div>
          </div>
          <div class="mt-3 col-12 col-lg-6">
            <div class="input-box">
              <label class="mb-0" for="">User Name</label>
              <input
                type="text"
                v-on:keyup.enter="save()"
                v-model="username"
                @focus="usernameEmpty = false"
                placeholder="example (Arun)"
              />
              <div v-if="usernameEmpty" style="color: red">
                UserName is required
              </div>
            </div>
          </div>
          <div class="mt-3 col-12 col-lg-6">
            <div class="input-box">
              <label class="mb-0" for="">Email</label>
              <input
                type="email"
                v-on:keyup.enter="save()"
                v-model="email"
                @focus="emailEmpty = false"
                placeholder="example@gmail.com"
              />
              <div v-if="emailEmpty" style="color: red">Email is required</div>
            </div>
          </div>
          <div class="mt-3 col-12 col-lg-6">
            <div class="input-box">
              <label for="">Role</label>
              <select v-model="role" @change="getRoles()" required>
                <option
                  v-for="(role, index) in roles"
                  :key="index"
                  :value="role.id"
                >
                  {{ role.role }}
                </option>
              </select>
              <div v-if="roleEmpty" style="color: red">Role is required</div>
            </div>
          </div>
          <div class="mt-3 col-12 col-lg-6">
            <div class="input-box">
              <label class="mb-0" for="">Password</label>
              <input
                type="text"
                v-on:keyup.enter="save()"
                v-model="password"
                @focus="passwordEmpty = false"
                placeholder="minimun 6 charector"
              />
              <div v-if="passwordEmpty" style="color: red">
                Password is required
              </div>
            </div>
          </div>
          <div class="mt-3 col-12 col-lg-6">
            <div class="input-box">
              <label class="mb-0" for="">Confirm Password</label>
              <input
                type="text"
                v-on:keyup.enter="save()"
                v-model="confirmpassword"
                @focus="
                  (confirmpasswordEmpty = false), (confirmpasswordMatch = false)
                "
                placeholder="minimun 6 charector"
              />
              <div v-if="confirmpasswordEmpty" style="color: red">
                confirm password is required
              </div>
              <div v-if="confirmpasswordMatch" style="color: red">
                password does not match required
              </div>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-end me-2">
          <!-- <button class="submit-btn">Submit</button> -->
          <button class="submit-btn" variant="success" @click="save()">
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import TopHeader from "../components/TopHeader.vue";
import axios from "axios";
// @ is an alias to /src

export default {
  name: "HomeView",
  components: { TopHeader },
  data() {
    return {
      name: "",
      nameEmpty: false,
      username: "",
      usernameEmpty: false,
      email: "",
      emailEmpty: false,
      password: "",
      passwordEmpty: false,
      confirmpassword: "",
      confirmpasswordEmpty: false,
      confirmpasswordMatch: false,
      role: "",
      roleEmpty: false,
      roles: [],
    };
  },
  mounted() {
    this.getRoles();
  },
  methods: {
    async getRoles() {
      await axios
        .get(`${this.$store.getters.baseUrl}/admin/create`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.roles = response.data.roles;
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
    async save() {
      if (this.name == "") {
        this.nameEmpty = true;
        return;
      }
      if (this.username == "") {
        this.usernameEmpty = true;
        return;
      }
      if (this.email == "") {
        this.emailEmpty = true;
        return;
      }
      if (this.password == "") {
        this.passwordEmpty = true;
        return;
      }
      if (this.confirmpassword == "") {
        this.confirmpasswordEmpty = true;
        return;
      }
      if (!(this.confirmpassword == this.password)) {
        this.confirmpasswordMatch = true;
        return;
      }
      if (this.role == "") {
        this.roleEmpty = true;
        return;
      }
      const formdata = new FormData();
      formdata.append("name", this.name);
      formdata.append("username", this.username);
      formdata.append("email", this.email);
      formdata.append("password", this.password);
      formdata.append("password_confirmation", this.confirmpassword);
      formdata.append("role_id", this.role);
      await axios
        .post(`${this.$store.getters.baseUrl}/admin`, formdata, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.$swal("Success", "Admin added successfully", "success");
            this.$router.push({ name: "users" });
            this.name = "";
            this.username = "";
            this.email = "";
            this.password = "";
            this.confirmpassword = "";
            this.role = "";
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },
  },
};
</script>
